import React from "react";
import { HomeBannerStyles, ReImagineStyles } from "../Styles";
import { Grid, Box, Typography } from "@mui/material";
import { getMeaning } from "../../utils/localization";

const DetailsCard = () => {
  return (
    // <Box sx={{ px: 4, py: 6 }}>
    <Box sx={ReImagineStyles.root}>
      <Grid container spacing={4} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          md={6}
          sx={{ width: { md: "50%" } }}
          // style={{ width: "50%" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              textAlign: "left",
            }}
          >
            <Typography
              sx={[
                HomeBannerStyles.bannerTitle,
                { fontSize: { xs: "1.3rem", sm: "1.3rem", md: "1.45rem" } },
              ]}
            >
              {getMeaning("ABTS.HDNG1")}
            </Typography>

            <Typography
              sx={[
                HomeBannerStyles.bannerTitle,
                { fontSize: { xs: "1.3rem", sm: "1.3rem", md: "1.45rem" } },
              ]}
            >
              {getMeaning("ABTS.HDNG2")}
            </Typography>

            <Typography
              sx={[
                HomeBannerStyles.bannerTitle,
                { fontSize: { xs: "1.3rem", sm: "1.3rem", md: "1.45rem" } },
              ]}
            >
              {getMeaning("ABTS.HDNG3")}
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontFamily: '"Poppins", sans-serif',
                color: "#555",
                mt: 2,
                fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
              }}
            >
              <b>{getMeaning("ABTS.ABT1")}</b> {getMeaning("ABTS.ABT2")}
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontFamily: '"Poppins", sans-serif',
                color: "#555",
                mt: 2,
                fontStyle: "italic",
                fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
              }}
            >
              {getMeaning("ABTS.ABT3")}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            component="img"
            // src={require("../../assets/images/About/AA-About.png")}
            src={require("../../assets/logo/AboutUsLogo.png")}
            alt="Mission"
            sx={{
              // width: "100%",
              maxWidth: "500px",
              height: "auto",
              borderRadius: 2,
              display: "block",
              mx: "auto",
              width: { xs: "300px", sm: "350px", md: "400px", lg: "500px" },
              mb: { xs: 5, sm: 5, md: 3, lg: 1 },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DetailsCard;
